<template>
    <div>
        <div class="clearbox"></div> 
        <img class="bannerbox"  src="../../static/images/banner2.jpg" /> 
        <div class="clearbox"></div>
        
        <div class="contentlist"> 
            <div class="index-width"> 
                <div class="listbox-left"> 
                    <div class="position">
                        <span>当前位置：<a ><router-link to="/">首页</router-link></a>&nbsp;&gt;&gt;&nbsp;<a @click="originRouter">新闻中心</a> <template v-if="type && type!='3'">&nbsp;&gt;&gt;&nbsp;<a >{{typeTitle}}</a></template></span>
                    </div> 
                    <ul class="list_c">
                        <li  v-for="(item,index) in listDataNew"><a @click="goDetails(item)" :data-detail='item'>{{item.text}}</a><span>{{item.time}}</span></li>
                    </ul>

                    <div id="pages" class="text-c">
                        <el-pagination
                            background
                            layout="prev, pager, next"
                            :total="1">
                        </el-pagination>
                    </div> 

                </div> 
                
                <boxRight :key="Date.now()" :mainTitle="mainTitle" :liData="liData" @routerData="routerData"></boxRight>
            </div> 
        </div> 
        <div class="clearbox"></div> 
        <footerNew></footerNew>
    </div>
</template>

<script>
    import boxRight from '@/component/listBoxRight.vue'
    import footerNew from '@/component/footerNew.vue'
    export default {
        components:{
			boxRight,
            footerNew					
		},
        name: "news",
        data(){
            return{
                mainTitle:"新闻中心",
                liData:[
                    {name:"公司新闻",routerTo:"news",type:"2",classification:'3-1'},
                    {name:"媒体新闻",routerTo:"news",type:"1",isActive:false,classification:'3-2'},
                ],
                listData:[
                    {text:'百台传祺GE3交付小易出行 打造高品质共享汽车',time:'2021-01-09',id:"1",type:"1"},
                    {text:'顺义区举办创新型产业集群和2025示范区重点项目推介会',time:'2020-12-26',id:"2",type:"1"},
                    {text:'未来充电站什么样？来看德国媒体追捧全球最大光伏充电站',time:'2020-12-25',id:"3",type:"1"},
                    {text:'创新有道 实践为基础 绿色出行大有可为',time:'2020-12-11',id:"4",type:"1"},
                    {text:'2019电动汽车产业生态发展论坛召开，撒豆网上线',time:'2019-11-29',id:"5",type:"1"},
                    {text:'第八届湘商大会郴州开幕 Tellus Power邵阳产业园项目正式签约',time:'2019-11-23',id:"6",type:"1"},
                    {text:'光伏超级新能源汽车充电站今在松江投入运营',time:'2018-12-18',id:"7",type:"1"},
                    {text:'独家丨给滴滴供车、购龙星化工之后 Tellus Power仍将有大举动',time:'2017-11-19',id:"8",type:"1"},
                    {text:'全球最大的光伏超级新能源汽车充电站今在松江投入运营',time:'2017-11-18',id:"9",type:"1"},
                    {text:'副总理莅临Tellus Power站点 指导新能源汽车产业发展',time:'-2017-07-06',id:"10",type:"1"},
                    {text:'“开始只想占领市场，没想到还盈利了”—Tellus Power庞雷专访',time:'2017-05-11',id:"11",type:"1"},
                    // {text:'Tellus Power2016年营收4.96亿元 净赚3765万元',time:'2017-05-02',id:"12",type:"1"},
                    {text:'360°纯帅!—吉利帝豪EV300 亮相北京Tellus Power新能源4S店',time:'2017-03-10',id:"13",type:"1"},
                    {text:'志同道合谋发展，携手并进创辉煌—国网;Tellus Power达成战略合作',time:'2017-01-19',id:"14",type:"1"},
                    {text:'玉树琼花满帝都 Tellus Power科技耀京城——Tellus Power集团亮相第七届北',time:'2016-11-29',id:"15",type:"1"},
                    {text:'帝都花开恰逢时，绿色新生正启程',time:'2016-09-22',id:"16",type:"1"},
                    {text:'央视专访--Tellus Power充电站运营新思路',time:'2016-05-31',id:"17",type:"1"},
                    {text:'发力新基建，集团开展移动大功率充电试点',time:'2021-07-10',id:"18",type:"2"},
                    {text:'中国充电联盟召开2018年度工作会议',time:'2021-01-22',id:"19",type:"2"},
                    {text:'Tellus Power集团·广汽新能源开展战略合作 携手提升用户使用体验',time:'2020-12-27',id:'20',type:"2"},
                    {text:'Tellus Power全产业链再发力，年产值45亿项目签约顺义',time:'2020-12-22',id:"21",type:"2"},
                    {text:'创新有道 实践为基 绿色出行大有可为',time:'2020-12-17',id:"22",type:"2"},
                    {text:'重磅签约 Tellus Power邵阳产业园项目正式签约邵阳',time:'2020-11-23',id:"23",type:"2"},
                    {text:'上海Tellus Power新能源光伏充电站盛大开幕',time:'2020-11-15',id:"24",type:"2"},
                    {text:'TE Carsharing',time:'2017-11-14',id:"25",type:"2"},
                    // {text:'',time:''},
                    // {text:'',time:''},
                ],
                type:'',
                typeTitle:"",
            }
        },
        methods:{
            goDetails(e){
                console.log(e)
               
                this.$router.push({name: "newsDetails",query:{data:e}});
            },
            routerData(e){
                console.log(e)
                if(e.type){
                    this.type = e.type
                    let listData = JSON.parse(JSON.stringify(this.listData))
                    if(e.type == '1'){
                        this.typeTitle = '媒体新闻'
                        this.liData[1].isActive = true
                        this.liData[0].isActive = false
                    }else if(e.type == '2'){
                        this.typeTitle = '公司新闻'
                        this.liData[0].isActive = true
                        this.liData[1].isActive = false
                    }
                    let listDataNew = listData.filter((item,index)=>{
                        if(item.type == e.type){
                            return item
                        }
                    })
                   
                    console.log(this.liData)
                    console.log(listDataNew)
                    this.listDataNew = listDataNew
                    this.$store.commit('newSet',e.classification)
                }
            },
            originRouter(){
                this.listDataNew =  JSON.parse(JSON.stringify(this.listData))
                this.type = ''
                this.typeTitle = ''
                this.liData.map((item,index)=>{
                    item.isActive = false
                })
                this.$store.commit('newSet','3-3')
            },
            initData(id){
                console.log(id)
                this.type = id
                if(id == '3'){
                    this.listDataNew =  JSON.parse(JSON.stringify(this.listData))
                    this.type = ''
                    this.typeTitle = ''
                    this.liData.map((item,index)=>{
                        item.isActive = false
                    })
                    this.$store.commit('newSet','3-3')
                    return
                    
                }
                this.listDataNew = JSON.parse(JSON.stringify(this.listData))
                if(this.type){
                    if(this.type == '1'){
                        this.typeTitle = '媒体新闻'
                        this.liData[1].isActive = true
                        this.liData[0].isActive = false
                    }else if(this.type == '2'){
                        this.typeTitle = '公司新闻'
                        this.liData[0].isActive = true
                        this.liData[1].isActive = false
                    }else{

                    }
                    let listDataNew = this.listData.filter((item,index)=>{
                        if(item.type == this.type){
                            return item
                        }
                    })
                    console.log(listDataNew)
                    this.listDataNew = listDataNew
                }
            },
        },
        watch:{
            $route(to,from){
                console.log(to,from)
                 
                this.initData(to.query.type)
            },
            '$store.state.id':{
                deep:true,
                immediate:true,
                handler(newval,oldval){
                    console.log(newval,oldval);
                    if(newval == '3-3'){
                        this.listDataNew =  JSON.parse(JSON.stringify(this.listData))
                        this.type = ''
                        this.typeTitle = ''
                        this.liData.map((item,index)=>{
                            item.isActive = false
                        })
                        this.$store.commit('newSet','3-3')
                        return
                    }
                }

            },
        },
        created(e){
            console.log(this.$route.query)
            let w = this.$route.query
            this.type = w.type
            this.listDataNew = JSON.parse(JSON.stringify(this.listData))
            if(this.type){
                if(this.type == '1'){
                   this.typeTitle = '媒体新闻'
                   this.liData[1].isActive = true
                }else if(this.type == '2'){
                    this.typeTitle = '公司新闻'
                    this.liData[0].isActive = true
                }else  if(this.type == '3'){
                    this.listDataNew = this.listData
                    return;
                }
                let listDataNew = this.listData.filter((item,index)=>{
                    if(item.type == this.type){
                        return item
                    }
                })
                console.log(listDataNew)
                this.listDataNew = listDataNew
            }
        }
    }
</script>

<style scoped>
.text-c {
    text-align: center;
}
#pages {
    padding: 14px 0 10px;
    font-family: 宋体;
    overflow: hidden;
    margin: 0 auto;
    width: 100%;
}
.contentlist .listbox-left ul.list_c li {
    width: 100%;
    float: left;
    line-height: 30px;
    box-sizing: border-box;
}
.contentlist .listbox-left ul.list_c li a {
    float: left;
    font-size: 14px;
    color: #333333;
}
.contentlist .listbox-left ul.list_c li span {
    color: #898989;
    font-size: 14px;
    float: right;
}
.contentlist .listbox-left ul.list_c li {
    width: 100%;
    float: left;
    line-height: 30px;
    box-sizing: border-box;
}
.contentlist .listbox-left ul.list_c {
    width: 100%;
    float: left;
    margin: 15px 0;
    overflow: hidden;
}
.detailClass{
    margin-top: 0px; 
    margin-bottom: 0px; 
    padding: 15px 0px 15px 65px; 
    border-width: 0px 0px 1px; 
    border-top-style: initial; 
    border-right-style: initial; 
    border-bottom-style: solid; 
    border-left-style: initial; 
    border-top-color: initial; 
    border-right-color: initial; 
    border-bottom-color: rgb(221, 221, 221); 
    border-left-color: initial; 
    border-image: initial; 
    font-size: 15px; 
    line-height: 28px;
}
.monClass{
    margin: 0px; 
    padding: 0px; 
    border: 0px; 
    width: 52px; 
    height: 28px; 
    display: block; 
    background-color: rgb(185, 185, 185); 
    text-align: center; 
    color: rgb(255, 255, 255); 
    font-size: 18px;
}
.ulClass{
    margin: 0px; 
    padding: 0px; 
    border: 0px; 
    /* width: 80%;  */
    /* float: right;  */
    position: relative;
}
.h2Class{
    /* margin: 0px 0px 0px; */
    margin-right: 50px;
    padding: 0px; 
    font-size: 18px !important; 
    width: 80px; 
    /* float: left;  */
    color: rgb(137, 137, 137); 
    line-height: 28px;
}
.contentlist .Articlebox .a-text-c {
    font-size: 14px;
    line-height: 28px;
    color: #333333;
    display: block;
    padding: 10px 20px;
    margin-top: 15px;
}
.contentlist .Articlebox h2 {
    font-size: 14px;
    color: #CCC;
    display: block;
    line-height: 22px;
    text-align: center;
}
.contentlist .Articlebox h1 {
    display: block;
    padding: 45px 0 5px;
    text-align: center;
    font-size: 19px;
}
.contentlist .Articlebox {
    width: 780px;
    float: left;
    min-height: 600px;
}
     ul, ol, li {
    list-style: none;
}
#pages {
    padding: 14px 0 10px;
    font-family: 宋体;
    overflow: hidden;
    margin: 0 auto;
    width: 100%;
}
.text-c {
    text-align: center;
}
.contentlist .listbox-left ul.list_c {
    width: 100%;
    float: left;
    margin: 15px 0;
    overflow: hidden;
}
.contentlist .listbox-left ul.list_c li a {
    float: left;
    font-size: 14px;
    color: #333333;
}
.contentlist .listbox-left ul.list_c li a:hover {
   
    color: #18D1BB;
}
.contentlist .listbox-left ul.list_c li span {
    color: #898989;
    font-size: 14px;
    float: right;
}
.contentlist .listbox-left ul.list_c li {
    width: 100%;
    float: left;
    line-height: 30px;
    box-sizing: border-box;
}
  .footerbox .fott-box2 {
    width: 100%;
    float: left;
    height: 50px;
}
.footerbox .fott-box2 .box2-right span {
    font-size: 14px;
    color: #181818;
    margin: 0 15px;
}
.footerbox .fott-box2 .box2-right {
    float: right;
    line-height: 50px;
    color: #e4e4e4;
    font-family: Tahoma;
}
  .contentlist .listbox-right {
    float: right;
    width: 200px;
}
.contentlist .listbox-right ul li a:hover, .contentlist .listbox-right ul li a.active {
    color: #18D1BB;
}
.contentlist .listbox-right ul li a {
    float: left;
    font-size: 14px;
    color: #000;
}
.contentlist .listbox-right ul li {
    width: 100%;
    float: left;
    line-height: 32px;
    box-sizing: border-box;
    padding-left: 15px;
    background: url(../../static/images/don.gif) no-repeat 5px center;
}
.footerbox {
    margin: 0 auto;
    width: 100%;
    overflow: hidden;
    background: url(../../static/images/bottom_bg.jpg) repeat-x left bottom;
}
.contentlist .listbox-right ul {
    width: 100%;
    float: left;
    margin: 15px 0;
    height: 128px;
}
.contentlist .listbox-right h2 span {
    line-height: 48px;
    font-size: 18px;
    color: #000;
    float: left;
    margin-left: 10px;
}
.contentlist .listbox-right h2 {
    width: 100%;
    height: 48px;
    background-color: #f8f8f8;
    padding: 0 10px;
    box-sizing: border-box;
}
  .contentlist .Articlebox {
    width: 780px;
    float: left;
    min-height: 600px;
}
div, form, ul, ol, li, span, p, dl, dt, dd, img {
    margin: 0;
    padding: 0;
    border: 0;
}
.contentlist .Articlebox .a-text-c {
    font-size: 14px;
    line-height: 28px;
    color: #333333;
    display: block;
    padding: 10px 20px;
    margin-top: 15px;
}
.contentlist .Articlebox h1 {
    display: block;
    padding: 45px 0 5px;
    text-align: center;
    font-size: 19px;
}
  a {
    color: #20366f;
    text-decoration: none;
}
  .position {
    width: 100%;
    float: left;
    border-bottom: 1px solid #dddddd;
    font-family: Tahoma;
    font-size: 14px;
    color: #666666;
    padding: 15px 0;
}
.position a, .position span {
    display: inline-block;
    font-size: 14px;
    color: #666666;
    margin: 0 5px;
}
    .contentlist .listbox-left {
        width: 760px;
        float: left;
    }
  .contentlist {
    margin: 30px auto 15px;
    overflow: hidden;
    width: 100%;
}
.index-width {
    width: 1000px;
    margin: 0 auto;
    position: relative;
}
  .bannerbox {
    margin: 0 auto;
    overflow: hidden;
    width: 100%;
    height: 208px;
    object-fit: cover;
}
  .clearbox {
    border-top: 1px solid transparent !important;
    margin-top: -1px !important;
    margin-top: 0px;
    clear: both;
    font-size: 0px;
    line-height: 0px;
    height: 0px;
    border: 0px;
    visibility: hidden;
}
    *{
      box-sizing: border-box;
      margin:0;
      padding:0;
    }
</style>